/** True if the browser can actually render a WebGL map (MapLibre needs it).
 *  Used to degrade gracefully instead of throwing on unsupported devices. */
export const isWebglSupported = (): boolean => {
  try {
    const canvas = document.createElement('canvas');
    return !!(
      window.WebGLRenderingContext &&
      (canvas.getContext('webgl') || canvas.getContext('experimental-webgl'))
    );
  } catch {
    return false;
  }
};
